import {
  SET_OSCILLOMETRY_VIEW,
  SET_OSCILLOMETRY_REQUEST_ID,
  SET_OSCILLOMETRY_TEST_STARTED,
  SET_OSCILLOMETRY_RESULT,
  SET_OSCILLOMETRY_ERROR,
  SET_OSCILLOMETRY_READBACK,
  SET_OSCILLOMETRY_CANONICAL_SESSION,
  RESET_OSCILLOMETRY_STATE,
  SET_OSCILLOMETRY_VISIT_LABELS,
  SET_OSCILLOMETRY_IQC_PERSIST_STATUS,
  SET_OSCILLOMETRY_BD_COMPARISON_EXPECTED,
} from './actionTypes';
import {
  IqcPersistStatus,
  OscillometryCanonicalSession,
  OscillometryReadbackState,
  OscillometryTestCompleteResult,
  OscillometryView,
} from './oscillometryReducer';

export const setOscillometryView = (view: OscillometryView) => ({
  type: SET_OSCILLOMETRY_VIEW,
  payload: view,
});

export const setOscillometryRequestId = (requestId: string) => ({
  type: SET_OSCILLOMETRY_REQUEST_ID,
  payload: requestId,
});

export const setOscillometryTestStarted = (timestamp: string) => ({
  type: SET_OSCILLOMETRY_TEST_STARTED,
  payload: timestamp,
});

export const setOscillometryResult = (result: OscillometryTestCompleteResult) => ({
  type: SET_OSCILLOMETRY_RESULT,
  payload: result,
});

export const setOscillometryError = (error: string) => ({
  type: SET_OSCILLOMETRY_ERROR,
  payload: error,
});

export const setOscillometryReadback = (readback: Partial<OscillometryReadbackState>) => ({
  type: SET_OSCILLOMETRY_READBACK,
  payload: readback,
});

export const setOscillometryCanonicalSession = (session: OscillometryCanonicalSession | null) => ({
  type: SET_OSCILLOMETRY_CANONICAL_SESSION,
  payload: session,
});

export const resetOscillometryState = () => ({
  type: RESET_OSCILLOMETRY_STATE,
});

export const setOscillometryVisitLabels = (labels: string[]) => ({
  type: SET_OSCILLOMETRY_VISIT_LABELS,
  payload: labels,
});

export const setIqcPersistStatus = (status: IqcPersistStatus) => ({
  type: SET_OSCILLOMETRY_IQC_PERSIST_STATUS,
  payload: status,
});

export const setOscillometryBdComparisonExpected = (expected: boolean) => ({
  type: SET_OSCILLOMETRY_BD_COMPARISON_EXPECTED,
  payload: expected,
});
